// @flow
import React from 'react';
import { FormattedMessage } from 'react-intl';

import styles from './SignupStep.css';
import Login from '../common/Login';

type OwnProps = {
  expanded: boolean,
  onLoginSuccess?: Function,
  subheader?: React$Element<typeof FormattedMessage>,
  onClickSignupLink?: Function,
};

type Props = OwnProps;

const LoginStep = ({ expanded, onLoginSuccess, onClickSignupLink }: Props) => {
  if (!expanded) {
    return null;
  }

  return (
    <div className={styles.container}>
      <Login onAuthComplete={onLoginSuccess} onClickSignupLink={onClickSignupLink} />
    </div>
  );
};

export default LoginStep;
